import { has, cloneDeep, get } from 'lodash'

import {
  CREATE_FLASH_MESSAGE,
  CLEAR_FLASH_MESSAGES
} from '../../actions/FlashMessages/consts'

const initialState = {
  messages: []
}

// Two flash messages are the same notice when they read the same and render in
// the same place. `data.tag` is what FlashMessage filters on, so it is the other
// half of the identity.
const isDuplicate = (messages, message, data) => messages.some(
  (m) => m.message === message && get(m, 'data.tag') === get(data, 'tag')
)

const handlers = {
  [CREATE_FLASH_MESSAGE]: (state, action) => {
    const { id, message, data } = action

    // Collapse an exact repeat (PD-30615). apiErrorMiddleware fires a flash for
    // every `*_ERROR` action, and one user action routinely produces several --
    // the CVT's Run Scenario makes one /plans/searches request per family plus a
    // plan-level one, so a single failure stacked three identical "An unknown
    // error has occurred." banners. Repeating a message adds no information; it
    // only pushes the page content down.
    //
    // The key is message + `data.tag`, the two things that decide what the user
    // reads and where it renders. `data.type` is deliberately NOT part of it:
    // the same sentence shown as an alert and as a success is still the same
    // sentence twice on one screen. Dismissal is unaffected -- one banner, one
    // id, one x -- and clearing it lets the message appear again next time.
    if (isDuplicate(state.messages, message, data)) { return state }

    const newMessages = cloneDeep(state.messages)
    newMessages.push({ id, message, data })

    return { ...state, messages: newMessages }
  },

  [CLEAR_FLASH_MESSAGES]: (state, action) => {
    const newMessages = cloneDeep(state.messages).filter((m) => !action.ids.includes(m.id))

    return { ...state, messages: newMessages }
  }
}

export default function FlashMessagesReducer(state = initialState, action) {
  if (has(handlers, action.type)) {
    return handlers[action.type](state, action)
  }

  return state
}
